import { __decorate } from "tslib";
import { LitElement, html, css } from 'lit';
import { customElement } from 'lit/decorators.js';
import { elements } from './sdb-elements.js';
/**
 * Card element, used to wrap content and display a white background
 *
 * @slot - Unnamed slot (default slot)
 * @attribute hidden - optional, used to hide the entire card
 *
 */
let SDBContentCard = class SDBContentCard extends LitElement {
    render() {
        return html ` <slot></slot> `;
    }
};
SDBContentCard.styles = [
    elements,
    css `
            :host {
                position: relative;
                display: block;
                background: var(--sdb-content-card-background, white);
                padding: 15px 20px 40px;
            }

            :host([hidden]),
            [hidden] {
                display: none;
            }
        `,
];
SDBContentCard = __decorate([
    customElement('sdb-content-card')
], SDBContentCard);
export { SDBContentCard };
//# sourceMappingURL=sdb-content-card.js.map